import ApiBase, { baseUrl } from '.';
import qs from 'qs';

export default class UserApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/User`, token);
  }

  getAll(keyword = '', skipCount = 0, maxResultCount = 10, roleIds = []) {
    return this.authHttp.get(`${this.baseUrl}/GetAll`, {
      params: {
        keyword,
        skipCount,
        maxResultCount,
        roleIds
      },
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
  }

  create(userName, name, surname, emailAddress, roleNames, isActive, password) {
    return this.authHttp.post(`${this.baseUrl}/Create`, {
      userName,
      name,
      surname,
      emailAddress,
      roleNames,
      isActive,
      password
    });
  }

  update(id, userName, name, surname, emailAddress, roleNames, isActive) {
    return this.authHttp.put(`${this.baseUrl}/Update`, {
      id,
      userName,
      name,
      surname,
      emailAddress,
      roleNames,
      isActive
    });
  }

  delete(id) {
    return this.authHttp.delete(`${this.baseUrl}/Delete`, { params: { id } });
  }

  getRoles() {
    return this.authHttp.get(`${this.baseUrl}/GetRoles`);
  }

  resetPassword(adminPassword, userId, newPassword) {
    return this.authHttp.post(`${this.baseUrl}/ResetPassword`, { adminPassword, userId, newPassword });
  }
}
